/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum EerderGeexamineerd {
    VOORLAATSTE_JAAR = "Voorlaatste jaar",
    GESPREID_EXAMEN = "Gespreid examen"
}
